import React, { Component } from 'react';
import IndexPage from './pages/indexPage';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './reducers/actions.js';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ApiHelper from './utils/apiHelper';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appSettings: null,  
      ready: false
    }
  }

  componentDidMount = () => {

    fetch("appSettings.json").then(
      function (res) {
        return res.json()
      }).then((data) => {
        ApiHelper.appSettings = data
        this.setState({ appSettings: data })       
        this.setState({ ready: true })

      }).catch(
        function (err) {
          console.log(err, ' error')
        }
      )
  }

  render() {

    return (
      <React.Fragment>
        {this.state.ready &&          
            <Router basename={`${process.env.PUBLIC_URL}`} >
              <IndexPage {...this.props} appSettings={this.state.appSettings}></IndexPage>
            </Router>
        }
        <ToastContainer />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
 
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
  mapStateToProps,
  mapDispatchToProps
))(App);

